function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  className: "outerCircle",
  cx: 19,
  cy: 19,
  r: 18.5,
  stroke: "#1DA1FA"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1DA1FA",
  fillRule: "nonzero",
  d: "M26.294 16.671c0-.158-.006-.311-.013-.463.7-.505 1.287-1.134 1.767-1.86-.64.284-1.32.474-2.031.565.73-.443 1.289-1.14 1.55-1.98-.68.413-1.433.704-2.234.868-.647-.701-1.569-1.134-2.574-1.134-1.951 0-3.522 1.61-3.522 3.583 0 .284.023.557.081.817-2.93-.145-5.522-1.573-7.264-3.748-.304.537-.483 1.15-.483 1.811 0 1.241.628 2.34 1.566 2.978-.567-.01-1.122-.178-1.592-.441v.04c0 1.74 1.221 3.187 2.823 3.52-.538.15-1.202.144-1.59.057.456 1.419 1.752 2.462 3.292 2.496-1.199.954-2.722 1.528-4.37 1.528-.288 0-.566-.013-.843-.048 1.562 1.023 3.411 1.607 5.407 1.607 6.485 0 10.03-5.461 10.03-10.196z"
}));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.09316dbf.svg";
export { ForwardRef as ReactComponent };